module.exports = __webpack_public_path__ + "resources/images/identiteitskaart-61c144e57d0c138ac3ab4e55298abbce-cache.jpg";